/** FROZEN (W0-contracts). Shell mounts once inside the signed-in providers. */
import type { ReactElement } from 'react';
import Runtime from './Runtime';

/** Consent and in-tab message alerts; Push owns permission/subscriptions and Calls owns ringing. */
export function MeRuntime(): ReactElement | null { return <Runtime />; }
